import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { fadeInRightAnimation } from 'src/@fury/animations/fade-in-right.animation';
import { fadeInUpAnimation } from 'src/@fury/animations/fade-in-up.animation';
import { scaleInAnimation } from 'src/@fury/animations/scale-in.animation';
import { ApiService } from 'src/app/services/api.service';
import { Location } from '@angular/common';

@Component({
  selector: 'fury-add-edit-review-url',
  templateUrl: './add-edit-review-url.component.html',
  styleUrls: ['./add-edit-review-url.component.scss'],
  animations: [fadeInUpAnimation, fadeInRightAnimation, scaleInAnimation],
})
export class AddEditReviewUrlComponent implements OnInit {
  reviewUrlForm!: FormGroup;
  parentlist = [];
  serviceId: string = '';
  constructor(
    private api: ApiService,
    private ar: ActivatedRoute,
    public location: Location
  ) { }

  ngOnInit(): void {
    this.ar.params.subscribe(res => { if (res) { this.serviceId = res['id']; if (this.serviceId) this.getServiceDetail() } })
     this.formInIt();
  }
  formInIt() {
    this.reviewUrlForm = new FormGroup<any>({
      type: new FormControl('', [Validators.required]),
      percentage: new FormControl('', [Validators.required]),
      isActive: new FormControl(true, [Validators.required]),
      url: new FormControl('', [Validators.required, Validators.pattern(/^(?:http(s)?:\/\/)?[\w.-]+(?:\.[\w\.-]+)+[\w\-\._~:/?#[\]@!\$&'\(\)\*\+,;=%.]+$/)])
    });
  }
 
  getServiceDetail() {
    this.api.get(`admin/review/review-url/get-review-url/${this.serviceId}`).subscribe({
      next: (res: any) => { 
        if (res?.body) {
          this.reviewUrlForm.patchValue(res.body.reviewUrl);
        }
      }
    })
  }
  submit() {
    if (this.reviewUrlForm.valid) {
      const data = this.reviewUrlForm.getRawValue();
    
      if(this.serviceId){
        this.api.patch(`admin/review/review-url/update-review-url/${this.serviceId}`, data).subscribe((res:any)=>{
          this.api.alert(res?.body.message, 'success');
          this.location.back();
        }, err=>{
          this.api.alert(err?.message, 'error');
        })
      } else{
        this.api.put('admin/review/review-url/create-review-url', data).subscribe((res:any)=>{
          this.api.alert(res.message, 'success');
          this.location.back();
        }, err =>{
          this.api.alert(err?.error?.message, 'error');
        })
      }
    } else { this.reviewUrlForm.markAllAsTouched() }
  }


}
